// extracted by mini-css-extract-plugin
export var cancelButton = "_mt-5";
export var content = "_mt-3";
export var createButton = "_mt-6";
export var drawerContainer = "_mt-0";
export var footer = "_mt-2";
export var header = "_mt-1";
export var orderFormColumn = "_mt-4";